import React from "react";
import { Link } from "react-router-dom";
import { CATEGORY_LABELS, COMMUNITY_IMAGE } from "@/lib/constants";
import { ArrowRight } from "lucide-react";

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};

export const ArticleCard = ({ article, testid }) => {
  return (
    <Link
      to={`/actualites/${article.slug}`}
      data-testid={testid}
      className="group bg-white border border-border rounded-sm overflow-hidden hover:shadow-md transition-shadow flex flex-col"
    >
      <div className="aspect-[16/10] overflow-hidden bg-slate-100">
        <img
          src={article.image_url || COMMUNITY_IMAGE}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-3 text-xs mb-3">
          <span className="bg-brand-green/10 text-brand-green font-semibold px-2.5 py-1 uppercase tracking-wide">
            {CATEGORY_LABELS[article.category] || article.category}
          </span>
          <span className="text-slate-400">{formatDate(article.published_at)}</span>
        </div>
        <h3 className="text-lg font-bold text-slate-900 leading-snug group-hover:text-brand-blue transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed line-clamp-3 flex-1">{article.summary}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue">
          Lire la suite <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  );
};

export { formatDate };
